import { render } from "./Create.vue?vue&type=template&id=3dc474e4"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render

export default script